var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSystemIo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 4H5.33333C4.59695 4 4 4.59695 4 5.33333V15.1111C4 15.8475 4.59695 16.4444 5.33333 16.4444H18.6667C19.403 16.4444 20 15.8475 20 15.1111V5.33333C20 4.59695 19.403 4 18.6667 4Z",
    stroke: "#667085",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55554 20H16.4444M12 16.4444V20",
    stroke: "#667085",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemIo);
export default __webpack_public_path__ + "static/media/systemIO.9ecb6086c94bc31296e423ce5de8f811.svg";
export { ForwardRef as ReactComponent };